const order = {
    state: {
        invoiceOrderList: [],//被选中需要开发票的订单
    },
  
    mutations: {
        setInvoiceOrderList: function (state, list) {
            state.invoiceOrderList = list
        },
    },
  
    actions: {
    }
}

export default order
